import {roundDecimalInteger, roundToInterval} from 'powtoon-commons/utils/numbers'
import {MINIMUM_STEP_SIZE} from 'powtoon-document/consts/duration'

export const updatePlaybackSettings = ({
  track,
  trackNewStartTime,
  trackNewEndTime,
  videoDuration,
  playbackSettings,
  isVoiceoverLogicActive,
  preservePlaybackSettingsEndTime
}) => {
  const {endTime: trackCurrentEndTime, startTime: trackCurrentStartTime} =  track
  const {endTime: psEndTime, startTime: psStartTime} = playbackSettings
  
  if (!(playbackSettings && videoDuration)) {
    // no relevent data
    return playbackSettings
  }
  const timeLineStepSize = MINIMUM_STEP_SIZE
  const isMeaningfulChangeStartTime = Math.abs(trackNewStartTime - trackCurrentStartTime) > timeLineStepSize
  const isMeaningfulChangeEndTime = Math.abs(trackNewEndTime - trackCurrentEndTime) > timeLineStepSize

  if (isMeaningfulChangeStartTime && isMeaningfulChangeEndTime) {
    // dragging action is not supposed to change playbackSettings
    return playbackSettings
  }
  const newStartTime = getStartTime({
    psStartTime,
    trackCurrentStartTime,
    trackNewStartTime,
    isVoiceoverLogicActive
  })

  const newEndTime = getEndTime({
    psEndTime,
    trackCurrentEndTime,
    trackNewEndTime,
    trackNewStartTime,
    videoDuration,
    isVoiceoverLogicActive,
    trackCurrentStartTime,
    preservePlaybackSettingsEndTime
  })

  const diffTimeSpanToSmall = newEndTime - newStartTime < timeLineStepSize
  const startTimeIncrement =  trackCurrentStartTime < trackNewStartTime

  const reAdjustedStartTime = diffTimeSpanToSmall && startTimeIncrement ?
    newEndTime - timeLineStepSize :
    newStartTime
  const reAdjustedEndTime = diffTimeSpanToSmall && !startTimeIncrement ?
    newStartTime + timeLineStepSize :
    newEndTime

  return {
    ...playbackSettings,
    endTime: roundToInterval(reAdjustedEndTime, MINIMUM_STEP_SIZE),
    startTime: roundToInterval(reAdjustedStartTime, MINIMUM_STEP_SIZE)
  }
}

export const getDefaultVideoPlaybackSettings = (data, startTime, endTime) => ({
  startTime: 0,
  endTime: getDefaultEndTime(data, startTime, endTime),
  isMuted: false
})

export const getEndTime = ({
  psEndTime,
  trackCurrentEndTime = 1, trackNewEndTime = 1,
  videoDuration, isVoiceoverLogicActive = false,
  trackNewStartTime, trackCurrentStartTime, preservePlaybackSettingsEndTime
}) => {
  
  let calculatedEndTime = psEndTime
  const deltaStartTime = Math.abs(trackCurrentStartTime - trackNewStartTime)
  const deltaEndTime =  Math.abs(trackCurrentEndTime - trackNewEndTime)
  
  if (deltaEndTime || deltaStartTime){
    if (!isVoiceoverLogicActive){
      calculatedEndTime = trackNewEndTime > trackCurrentEndTime?
        psEndTime + deltaEndTime:
        preservePlaybackSettingsEndTime ? psEndTime : psEndTime - deltaEndTime

    } else {
      const trackDurationBiggerThanAssetDuration = Math.abs(trackNewEndTime - trackNewStartTime) > videoDuration
      const playbackEndTimeBiggerThanDuration = psEndTime > videoDuration
      const isSetAssetDuration = trackDurationBiggerThanAssetDuration || playbackEndTimeBiggerThanDuration
      if (isSetAssetDuration ){
        calculatedEndTime = videoDuration
      }
      else {
        const oldDuration = trackCurrentEndTime - trackCurrentStartTime
        const wasDurationSmallerThenOldEndTime =  oldDuration > videoDuration
          
        if (deltaEndTime){
          const refinedDeltaEndTime = wasDurationSmallerThenOldEndTime?
            deltaEndTime - (oldDuration - videoDuration)  :
            deltaEndTime

          calculatedEndTime = trackNewEndTime > trackCurrentEndTime ?
            psEndTime + deltaEndTime :
            psEndTime - refinedDeltaEndTime // the bug is here
        }
        if (deltaStartTime) {
          const refinedDeltaStartTime = wasDurationSmallerThenOldEndTime?
            deltaStartTime - (oldDuration - videoDuration)  :
            deltaStartTime
          calculatedEndTime = trackNewStartTime > trackCurrentStartTime ?
            psEndTime - refinedDeltaStartTime :
            psEndTime + deltaStartTime
        }
      }
      return Math.max(Math.min(calculatedEndTime, videoDuration), 0)
    }
  }
  return Math.max(Math.min(roundDecimalInteger(calculatedEndTime), videoDuration), 0)
}
const getDefaultEndTime = (data, startTime = 0, endTime = 1) => {
  const videoDataDuration = data?.videoData?.duration ?? endTime
  return getValidEndTime(endTime - startTime, videoDataDuration)
}

export const getValidEndTime = (trackNewDuration = 0, videoDataDuration= 0) =>
  roundDecimalInteger(Math.min(Math.max(trackNewDuration, 0), videoDataDuration))

export const getStartTime = ({
  psStartTime, trackCurrentStartTime = 0,
  trackNewStartTime, isVoiceoverLogicActive
}) => {

  if (isVoiceoverLogicActive){
    // on VoiceOver time line the left handle wont effect  playbackSettings.startTime only the endTime
    // see VCP-732 LipSync - Timeline behavior update
    return 0
  }
  const deltaStartTime = Math.abs( trackCurrentStartTime - trackNewStartTime) || 0
  const calculatedStartTime = trackCurrentStartTime > trackNewStartTime?
    psStartTime - deltaStartTime:
    psStartTime + deltaStartTime

  return Math.max(roundDecimalInteger(calculatedStartTime), 0)
}
